export interface ConditionalProps {
  condition: boolean | (() => boolean);
  children: React.ReactNode;
}

function getResult(condition: unknown) {
  if (typeof condition === "function") {
    return Boolean(condition());
  }

  return Boolean(condition);
}

/**
 * A component that renders its children if the condition is false.
 */
export function Unless(props: ConditionalProps) {
  const shouldRender = !getResult(props.condition);
  return shouldRender ? <>{props.children}</> : null;
}

/**
 * A component that renders its children if the condition is true.
 */
export function When(props: ConditionalProps) {
  const shouldRender = getResult(props.condition);
  return shouldRender ? <>{props.children}</> : null;
}
